<template>
  <div :class="classes" ref="ellipsis">
        <!-- 文本插槽 -->
        <slot />
    </div>
</template>

<script>
/**
 * 文本溢出显示组件，单行，多行均适用
 * @vuedoc
 * @exports base/wt-text
 */
// 组件class前缀
const prefixCls = 'wt-text'

export default {
  name: 'wt-text',
  props: {
    // 最大显示行
    row: {
      type: [String, Number],
      default: 1
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    ellipsis () {
      return this.$refs.ellipsis
    }
  },
  methods: {
    getStyle (element) {
      if (element.currentStyle) {
        return element.currentStyle
      } else {
        return getComputedStyle(element, false)
      }
    },
    // 更新组件高度
    setStyle () {
      this.$nextTick(_ => {
        this.ellipsis.style['-webkit-line-clamp'] = this.row
        // let computedStyle = this.getStyle(this.ellipsis)
        let lineHeight = this.ellipsis.offsetHeight
        lineHeight && (this.ellipsis.style['max-height'] = this.row * lineHeight + 'px')
      })
    }
  },
  mounted () {
    this.setStyle()
  }
}
</script>

<style lang="less">
.wt-text{
    display:-webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    //这里用微元素是为了将div高度撑起来，避免在没内容时高度为0
    &::before{
        content:'a';
        display:inline-block;
        width:0;
        visibility: hidden;
    }
}
</style>
